 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"address":"address","basic":"basic","biddingDetail":"biddingDetail","binding":"binding","caseDetail":"caseDetail","classSearch":"classSearch","code":"code","collect":"collect","demandDetail~myCollect~notice~priceDetail~quoteMerchant~transaction~view-main":"demandDetail~myCollect~notice~priceDetail~quoteMerchant~transaction~view-main","demandDetail~order~orderPrice~requirement":"demandDetail~order~orderPrice~requirement","demandDetail":"demandDetail","myCollect":"myCollect","notice":"notice","priceDetail":"priceDetail","quoteMerchant":"quoteMerchant","transaction":"transaction","view-main":"view-main","order":"order","orderPrice":"orderPrice","requirement":"requirement","dynamicDetail":"dynamicDetail","dynamicList":"dynamicList","forget":"forget","help":"help","helpCenter":"helpCenter","home":"home","infoDetail":"infoDetail","infoList":"infoList","integral":"integral","invoice":"invoice","login":"login","logonbind":"logonbind","myAfter":"myAfter","myComment":"myComment","myNeeds":"myNeeds","myPrice":"myPrice","mycenter":"mycenter","orderDetail":"orderDetail","payFail":"payFail","paySuccess":"paySuccess","phonebind":"phonebind","product":"product","productDetail":"productDetail","productList":"productList","purchaseOrder":"purchaseOrder","register":"register","renting":"renting","requirementSuccess":"requirementSuccess","return":"return","searchProduct":"searchProduct","searchshop":"searchshop","security":"security","shopPage":"shopPage","shopSelect":"shopSelect","success":"success","tenderOrder":"tenderOrder"}[chunkId]||chunkId) + "." + {"address":"4f0d3cec","basic":"0c4d73e8","biddingDetail":"9c6fa08d","binding":"dd1cf2d0","caseDetail":"fd492f26","classSearch":"db924a61","code":"33597095","collect":"1eb017f4","demandDetail~myCollect~notice~priceDetail~quoteMerchant~transaction~view-main":"17dec740","demandDetail~order~orderPrice~requirement":"b7de4b0c","demandDetail":"79379495","myCollect":"e98bd399","notice":"2b0e4ea2","priceDetail":"5f2de413","quoteMerchant":"507fc6ea","transaction":"157bd739","view-main":"f1b53cb4","order":"df4cf42c","orderPrice":"b189dfb1","requirement":"595e0b6a","dynamicDetail":"f526c1e9","dynamicList":"b34988e9","forget":"b3c70c19","help":"3d8b3f4d","helpCenter":"42e46645","home":"d1c9a2a1","infoDetail":"f455c106","infoList":"aaa57d6d","integral":"4590bbe8","invoice":"e602e52c","login":"c6638a61","logonbind":"619ed028","myAfter":"e4b00da8","myComment":"82f354a3","myNeeds":"5ee984b7","myPrice":"04c49e52","mycenter":"bb32885d","orderDetail":"6d8d5bea","payFail":"73480922","paySuccess":"a5685a92","phonebind":"ca4e42ae","product":"e7656b80","productDetail":"2c413f96","productList":"3b55a1ce","purchaseOrder":"c2f2046f","register":"83257251","renting":"b671cfab","requirementSuccess":"d823704e","return":"149e4f4a","searchProduct":"8268e6da","searchshop":"0b1066b2","security":"1a73863c","shopPage":"7a9b9111","shopSelect":"2766f826","success":"52207264","tenderOrder":"74b6d2a6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"address":1,"basic":1,"biddingDetail":1,"binding":1,"caseDetail":1,"classSearch":1,"code":1,"collect":1,"demandDetail~myCollect~notice~priceDetail~quoteMerchant~transaction~view-main":1,"demandDetail~order~orderPrice~requirement":1,"demandDetail":1,"myCollect":1,"notice":1,"priceDetail":1,"quoteMerchant":1,"transaction":1,"view-main":1,"order":1,"orderPrice":1,"requirement":1,"dynamicDetail":1,"dynamicList":1,"forget":1,"help":1,"helpCenter":1,"home":1,"infoDetail":1,"infoList":1,"integral":1,"invoice":1,"login":1,"logonbind":1,"myAfter":1,"myComment":1,"myNeeds":1,"myPrice":1,"mycenter":1,"orderDetail":1,"payFail":1,"paySuccess":1,"phonebind":1,"product":1,"productDetail":1,"productList":1,"purchaseOrder":1,"register":1,"renting":1,"requirementSuccess":1,"return":1,"searchProduct":1,"searchshop":1,"security":1,"shopPage":1,"shopSelect":1,"success":1,"tenderOrder":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"address":"address","basic":"basic","biddingDetail":"biddingDetail","binding":"binding","caseDetail":"caseDetail","classSearch":"classSearch","code":"code","collect":"collect","demandDetail~myCollect~notice~priceDetail~quoteMerchant~transaction~view-main":"demandDetail~myCollect~notice~priceDetail~quoteMerchant~transaction~view-main","demandDetail~order~orderPrice~requirement":"demandDetail~order~orderPrice~requirement","demandDetail":"demandDetail","myCollect":"myCollect","notice":"notice","priceDetail":"priceDetail","quoteMerchant":"quoteMerchant","transaction":"transaction","view-main":"view-main","order":"order","orderPrice":"orderPrice","requirement":"requirement","dynamicDetail":"dynamicDetail","dynamicList":"dynamicList","forget":"forget","help":"help","helpCenter":"helpCenter","home":"home","infoDetail":"infoDetail","infoList":"infoList","integral":"integral","invoice":"invoice","login":"login","logonbind":"logonbind","myAfter":"myAfter","myComment":"myComment","myNeeds":"myNeeds","myPrice":"myPrice","mycenter":"mycenter","orderDetail":"orderDetail","payFail":"payFail","paySuccess":"paySuccess","phonebind":"phonebind","product":"product","productDetail":"productDetail","productList":"productList","purchaseOrder":"purchaseOrder","register":"register","renting":"renting","requirementSuccess":"requirementSuccess","return":"return","searchProduct":"searchProduct","searchshop":"searchshop","security":"security","shopPage":"shopPage","shopSelect":"shopSelect","success":"success","tenderOrder":"tenderOrder"}[chunkId]||chunkId) + "." + {"address":"3748bf8a","basic":"b507705e","biddingDetail":"4ffc61a8","binding":"6f0679da","caseDetail":"3e24812d","classSearch":"04c308ab","code":"6ee2e174","collect":"ea9ce494","demandDetail~myCollect~notice~priceDetail~quoteMerchant~transaction~view-main":"14f805f9","demandDetail~order~orderPrice~requirement":"024fcb4e","demandDetail":"ab906f04","myCollect":"c0c4f9c1","notice":"2d855a46","priceDetail":"7402dcb5","quoteMerchant":"cc4a48f6","transaction":"8d99a891","view-main":"71727600","order":"d4cac552","orderPrice":"1fe6d643","requirement":"95c2e7d9","dynamicDetail":"a079fc7f","dynamicList":"9f6de260","forget":"02820ef5","help":"95d6cc61","helpCenter":"be8b6563","home":"91fb43ad","infoDetail":"4733274b","infoList":"c0718b86","integral":"79ca7146","invoice":"a947a24e","login":"32666377","logonbind":"a3d36caf","myAfter":"8d34441e","myComment":"94ac5a16","myNeeds":"cc1aa8f1","myPrice":"61b62e5f","mycenter":"e73e0677","orderDetail":"47e766b6","payFail":"a538c7bd","paySuccess":"ed9a3528","phonebind":"485cd699","product":"8f5cdfb0","productDetail":"53ac5aac","productList":"aa5ebf67","purchaseOrder":"b2fe3178","register":"c6c831a6","renting":"6d1fa111","requirementSuccess":"f468e157","return":"e481576d","searchProduct":"8f705a5b","searchshop":"626a5873","security":"28e84242","shopPage":"d91a070e","shopSelect":"b621f593","success":"159e0a39","tenderOrder":"c48292bc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
